import { ConditionItem } from './condition-item';
import { CoordinatorService } from './coordinator.service';
import { ValueItem } from './value-item';

export class RatingConnector {
    constructor(
        private coords: CoordinatorService,
        private xitmId: string,
    ) {}
}

export class TagConnector {
    constructor(
        private coords: CoordinatorService,
        private xitmId: string,
    ) {}
}

export class SubsetConnector {
    constructor(
        private coords: CoordinatorService,
        private xitmId: string,
    ) {}

    has(key: string): boolean {
        key = this.coords.utils$.normalizeString(key);
        for (const v of this.coords.view$.sortedViewLs)
            if (this.coords.utils$.normalizeString(v.title) === key) return v.has(this.xitmId);
        return false;
    }
}

export class ConditionConnector {
    templateMap: Map<string, any> = new Map();
    #conditionLs: ConditionItem[] = [];

    constructor(
        private coords: CoordinatorService,
        conditionLs: ConditionItem[] | undefined,
    ) {
        this.#conditionLs = conditionLs || [];
    }

    has(key: string): boolean {
        let resp = this.templateMap.get(key);
        if (resp !== undefined) return resp;
        key = this.coords.utils$.normalizeString(key);
        const tpl = key.split('/').map((k) => k.trim());
        for (const c of this.#conditionLs) {
            if (c.hasField(tpl)) return true;
        }
        return false;
    }
}

export class ValueConnector {
    templateMap: Map<string, any> = new Map();
    #valueItemLs: ValueItem[] = [];

    constructor(
        private coords: CoordinatorService,
        valueItemLs: ValueItem[] | undefined,
    ) {
        this.#valueItemLs = valueItemLs || [];
    }

    // Define a getter for accessing the map using property syntax
    get(key: string): any[] | Set<string> | null | undefined {
        let resp = this.templateMap.get(key);
        if (resp !== undefined) return resp;
        key = this.coords.utils$.normalizeString(key);
        const tpl = key.split('/').map((k) => k.trim());
        const respLs: any[] = [];
        this.#valueItemLs.forEach((vi) => respLs.push(...vi.getField(tpl)));

        switch (respLs.length) {
            case 0:
                const templ = this.coords.valueItem$.templateByName(tpl[0]);
                if (!templ) return undefined;
                const f = templ.fieldByName(tpl[1]);
                if (!f) return undefined;
                if (f.kind === 'choice' || f.kind === 'multichoice') return new Set<string>();
                break;
            case 1:
                resp = respLs[0];
                break;
            default:
                resp = new Set(respLs);
                break;
        }
        this.templateMap.set(key, resp);
        return resp;
    }
}
